import React from "react";
import { directHighlight, setQueryHyperlink } from 'components/lotto/utility/Utility.js';

function StatGroup({ title, subtitle, items, slug, accent }) {
  if (!items?.length) return null;

  return (
    <div className={`stat-group stat-group--${accent}`}>
      <header className="stat-group__header">
        <h3 className="stat-group__title">{title}</h3>
        <p className="stat-group__subtitle">{subtitle}</p>
      </header>
      <ul className="stat-group__list">
        {items.map((r, i) => {
          const isMatch =
            slug.slice(-2) === r.lotto ||
            (slug.length > 2 && slug.slice(-3) === r.lotto);
          const isTop = i <= 2;

          return (
            <li
              key={i}
              className={`stat-card${isMatch ? ' stat-card--match' : ''}${isTop ? ' stat-card--top' : ''}`}
            >
              <div className="stat-card__number">
                {isMatch
                  ? directHighlight(setQueryHyperlink(r.lotto, null))
                  : setQueryHyperlink(r.lotto, null)}
              </div>
              <div className="stat-card__meta">
                <span>ถูก {r.times} งวด</span>
                <span className="stat-card__rate">
                  {isMatch ? directHighlight(`${r.winRate}%`) : `${r.winRate}%`}
                </span>
              </div>
              {isTop && <span className="stat-card__badge">TOP {i + 1}</span>}
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default function LottoTopList({ results, slug }) {
  if (!results) return null;

  return (
    <div className="stat-groups">
      <StatGroup
        title="สองตัวล่าง"
        subtitle={`${results.down2DigitsTopList?.length || 0} อันดับ · ย้อนหลัง ${results.down2DigitsTopList?.[0]?.totalTimes || '-'} งวด`}
        items={results.down2DigitsTopList}
        slug={slug}
        accent="down"
      />
      <StatGroup
        title="สองตัวบน"
        subtitle={`${results.up2DigitsTopList?.length || 0} อันดับ · ย้อนหลัง ${results.up2DigitsTopList?.[0]?.totalTimes || '-'} งวด`}
        items={results.up2DigitsTopList}
        slug={slug}
        accent="up"
      />
      <StatGroup
        title="สามตัวบน"
        subtitle={`${results.up3DigitsTopList?.length || 0} อันดับ · ย้อนหลัง ${results.up3DigitsTopList?.[0]?.totalTimes || '-'} งวด`}
        items={results.up3DigitsTopList}
        slug={slug}
        accent="up3"
      />
    </div>
  );
}
